module.exports = __webpack_public_path__ + "static/media/MX.37bd5548.png";